import { render, staticRenderFns } from "./awakenTest.vue?vue&type=template&id=19b7bc33&scoped=true"
import script from "./awakenTest.vue?vue&type=script&lang=js"
export * from "./awakenTest.vue?vue&type=script&lang=js"
import style0 from "./awakenTest.vue?vue&type=style&index=0&id=19b7bc33&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19b7bc33",
  null
  
)

export default component.exports